<template>
  <div class="carousel">
    <div class="carousel-images">
      <transition name="fade" mode="out-in">
        <img
            :key="currentIndex"
            :src="images[currentIndex]"
            alt="Carousel Image"
            @click="showBigImage(images[currentIndex])"
        />
      </transition>
    </div>

    <!-- 控制按钮 -->
    <button
        v-if="showNavigation"
        class="nav-arrow prev"
        @click="prevImage"
    >&lt;</button>
    <button
        v-if="showNavigation"
        class="nav-arrow next"
        @click="nextImage"
    >&gt;</button>

    <!-- 删除按钮 -->
    <el-button
        type = "danger"
        v-if="showDelete"
        icon="el-icon-delete"
        class="delete-btn"
        @click.stop="handleDelete"
        circle></el-button>

    <!-- 图片索引显示 -->
    <div class="index" v-if="showIndex">
      <span>{{ currentIndex + 1 }} / {{ images.length }}</span>
    </div>

    <!-- 大图模态框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" @close="dialogVisible = false">
      <div class="big-image-container">
        <img :src="currentImage" alt="Big Image" class="big-image" />
        <button class="nav-arrow prev" @click="prevImage">&lt;</button>
        <button class="nav-arrow next" @click="nextImage">&gt;</button>
        <el-button
            type = "danger"
            v-if="showDelete"
            class="delete-btn"
            icon="el-icon-delete"
            @click.stop="handleDelete"
            circle></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true
    },
    autoPlayInterval: {
      type: Number,
      default: 3000
    },
    showNavigation: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      dialogVisible: false,
      currentImage: ''
    };
  },
  methods: {
    prevImage() {
      this.stopAutoPlay();
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.currentImage = this.images[this.currentIndex];
      this.startAutoPlay();
    },
    nextImage() {
      this.stopAutoPlay();
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.currentImage = this.images[this.currentIndex];
      this.startAutoPlay();
    },
    startAutoPlay() {
      this.intervalId = setInterval(() => {
        this.nextImage();
      }, this.autoPlayInterval);
    },
    stopAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    showBigImage(image) {
      this.currentImage = image;
      this.dialogVisible = true;
      this.currentIndex = this.images.indexOf(image);
    },
    handleDelete() {
      this.$emit('delete-image', this.currentIndex);
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  }
};
</script>

<style scoped>
.carousel {
  position: relative;
  width: 600px;
  height: 300px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-images img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.5s ease-in-out;
  cursor: pointer;
}

/* 优化后的导航按钮样式 */
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
  border: none;
  //width: 40px;
  //height: 40px;
  //font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.nav-arrow:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.nav-arrow.prev {
  left: 15px;
}

.nav-arrow.next {
  right: 15px;
}

/* 删除按钮样式 */
.delete-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: rgba(255, 0, 0, 0.5);
  color: white;
  border: none;
  width: 30px;
  height: 30px;
  font-size: 18px;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.delete-btn:hover {
  background-color: rgba(255, 0, 0, 0.7);
}

.index {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
}

.big-image {
  width: 100%;
  height: auto;
  //max-height: 70vh;
}

.big-image-container {
  position: relative;
}

.big-image-container .nav-arrow {
  width: 50px;
  height: 50px;
  font-size: 30px;
}

.big-image-container .delete-btn {
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  font-size: 24px;
}
</style>